<template>
    <div id="patient-side-card">
        <div>
            <i class="fa fa-times fa-2x w3-text-gray cursor-pointer card-closer flow-padding-top"
               @click="onClose" :title="$t('close')"></i>
            <router-link
                class="fa fa-external-link-alt w3-right w3-margin-right w3-xlarge w3-text-gray cursor-pointer card-closer flow-padding-top flow-blue-color"
                target="_blank"
                :to="{ name: 'patient', params: { id: propsPatient.id }}"
                :title="$t('goToPatientDetail')">
            </router-link>

            <!--TODO use this to display the QR code, might have to make it a function  -->
            <a v-if="isCurrentUserAdmin()" class="w3-right w3-margin-right"
            @click.prevent="openQrWindow"
            href="#">
                QR CODE
            </a>

            <span class="flow-margin-left-35-pct">
                <span class="fa fa-stack w3-large cursor-pointer zero w3-ripple w3-margin-right"
                      @click="openCard(0)"
                      :title="$t('patientInformation')">
                    <i class="fa fa-stack-2x fa-circle w3-text-white transform-animation"
                       v-bind:class="openPatientInfoCard ? 'halo-text' : ''"></i>
                    <i class="flow-blue2-text fa fa-stack-1x fa-user-alt fa-inverse w3-xlarge"></i>
                </span>

                <span class="fa fa-stack w3-large cursor-pointer zero w3-ripple w3-margin-right"
                      @click="openCard(1)"
                      :title="$t('appointments')">
                    <i class="fa fa-stack-2x fa-circle w3-text-white transform-animation"
                       v-bind:class="openPatientAppointmentsCard ? 'halo-text' : ''"></i>
                    <i class="fa fa-stack-1x fa-clipboard-list w3-text-teal w3-xlarge"></i>
                </span>

                <span class="fa fa-stack w3-large cursor-pointer zero w3-ripple w3-margin-right"
                      @click="openCard(2)"
                      :title="$t('personalDetails')">
                    <i class="fa fa-stack-2x fa-circle w3-text-white transform-animation"
                       v-bind:class="openPatientPersonalCard ? 'halo-text' : ''"></i>
                    <i class="far fa-stack-1x fa-id-card w3-xlarge flow-orange-text"></i>
                </span>
            </span>
        </div>

        <div>
            <h4 class="flow-blue-color zero-bottom flow-form-title w3-animate-opacity">
                <patient-status class="w3-show-inline-block flow-margin-right"
                                :status="selectedPatientStatus"
                                :showMarker="true">
                </patient-status>
                <patient-name-header :props-patient="propsPatient"
                                     :selected-patient-device="selectedPatientDevice">
                </patient-name-header>
            </h4>
        </div>

        <div>
            <patient-info class="w3-animate-opacity"
                          v-bind:class="!openPatientInfoCard ? 'w3-hide' : ''"
                          :propsPatientId="propsPatient.id">
            </patient-info>

            <patient-appointment class="w3-animate-opacity"
                                 v-bind:class="!openPatientAppointmentsCard ? 'w3-hide' : ''"
                                 :propsPatientId="propsPatient.id">
            </patient-appointment>

            <patient-personal-data class="w3-animate-opacity"
                                   v-bind:class="!openPatientPersonalCard ? 'w3-hide' : ''"
                                   :propsPatientId="propsPatient.id">
            </patient-personal-data>
        </div>
        

    </div>
</template>

<script>
    import PatientStatus from "../common/PatientStatus";
    import PatientInfo from "./PatientInfo";
    import PatientAppointment from "./PatientAppointment";
    import PatientPersonalData from "./PatientPersonalData";
    import PatientNameHeader from "../common/PatientNameHeader";
    import Vue from "vue";
    const frc = Vue.prototype.$frc;

    export default {
        name: "PatientSideCard",
        components: {PatientPersonalData, PatientAppointment, PatientInfo, PatientStatus, PatientNameHeader},
        props: ["selectedPatient", "onClose", "selectedPatientStatus", "selectedPatientDevice"],
        data() {
            return {
                openPatientInfoCard: true,
                openPatientAppointmentsCard: false,
                openPatientPersonalCard: false,
                propsPatient: {}
            }
        },
        created() {
            this.propsPatient = this.selectedPatient;
        },
        watch: {
            selectedPatient: function(newVal, oldVal) {
                this.propsPatient = newVal.id ? newVal : oldVal;
            }
        },
        methods: {
            openCard(index) {
                this.openPatientInfoCard = index === 0;
                this.openPatientAppointmentsCard = index === 1;
                this.openPatientPersonalCard = index === 2;
            },
            openQrWindow(){
                var app = this;
                frc.getAccessControlForPatientId(this.propsPatient.id).then(response => {
                    console.log(response);
                    var link = frc.getQrLink(response.data.externalReferenceId);        
                    window.open(link,"_blank");
                })
            }
        }
    }
</script>

<style scoped>

</style>